// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"dbb0df52","206":"356d01a7","423":"95c43875","578":"a686f19d","838":"bea80cd1","941":"09f4bbbb"}[chunkId] + ".chunk.js";
};